export default "__VITE_ASSET__d8288f6f__"